import React from 'react'
import { useTranslation } from 'react-i18next'
import {Typography} from 'antd'
import {observer} from 'mobx-react'
import {Button, Modal} from '@/components'
import {RegistrationSuccessfulModalProps} from './props'

import styles from './styles.scss'

export const RegistrationSuccessfulModal = observer(
    ({onOk, ...restProps}: RegistrationSuccessfulModalProps) => {
        const {t} = useTranslation()
        const footer = [
            <Button
                type='primary'
                onClick={(e) => onOk?.(e as React.MouseEvent<HTMLButtonElement>)}
            >
                {t('RegistrationSuccessfulModal.login')}
            </Button>
        ]

        return (
            <Modal maskClosable={false} footer={footer} {...restProps}>
                <div className={styles.inner}>
                    <div className={styles.balloons}></div>

                    <Typography.Title level={5} className={styles.title}>
                        {t('RegistrationSuccessfulModal.title')}
                    </Typography.Title>
                    <Typography.Text> {t('RegistrationSuccessfulModal.text')} </Typography.Text>
                </div>
            </Modal>
        )
    }
)
